/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface TestEdiDeliveryConnectionResponse
 */
export interface TestEdiDeliveryConnectionResponse {
  /**
   *
   * @type {boolean}
   * @memberof TestEdiDeliveryConnectionResponse
   */
  success: boolean;
  /**
   *
   * @type {number}
   * @memberof TestEdiDeliveryConnectionResponse
   */
  entriesFound?: number | null;
  /**
   *
   * @type {string}
   * @memberof TestEdiDeliveryConnectionResponse
   */
  loginDirectory?: string | null;
  /**
   *
   * @type {string}
   * @memberof TestEdiDeliveryConnectionResponse
   */
  error?: string | null;
}

/**
 * Check if a given object implements the TestEdiDeliveryConnectionResponse interface.
 */
export function instanceOfTestEdiDeliveryConnectionResponse(
  value: object,
): value is TestEdiDeliveryConnectionResponse {
  if (!("success" in value) || value["success"] === undefined) return false;
  return true;
}

export function TestEdiDeliveryConnectionResponseFromJSON(
  json: any,
): TestEdiDeliveryConnectionResponse {
  return TestEdiDeliveryConnectionResponseFromJSONTyped(json, false);
}

export function TestEdiDeliveryConnectionResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TestEdiDeliveryConnectionResponse {
  if (json == null) {
    return json;
  }
  return {
    success: json["success"],
    entriesFound:
      json["entriesFound"] == null ? undefined : json["entriesFound"],
    loginDirectory:
      json["loginDirectory"] == null ? undefined : json["loginDirectory"],
    error: json["error"] == null ? undefined : json["error"],
  };
}

export function TestEdiDeliveryConnectionResponseToJSON(
  json: any,
): TestEdiDeliveryConnectionResponse {
  return TestEdiDeliveryConnectionResponseToJSONTyped(json, false);
}

export function TestEdiDeliveryConnectionResponseToJSONTyped(
  value?: TestEdiDeliveryConnectionResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    success: value["success"],
    entriesFound: value["entriesFound"],
    loginDirectory: value["loginDirectory"],
    error: value["error"],
  };
}
